import * as z from "zod";

// Gift card settings schema
export const giftCardSettingsSchema = z.object({
  giftCardOptions: z.object({
    isPurchaseEnabled: z.boolean(),
    isRedemptionEnabled: z.boolean(),
  }),
});